export const isProductionEnvironment = process.env.NODE_ENV === "production";
export const isDevelopmentEnvironment = process.env.NODE_ENV === "development";
export const isTestEnvironment = Boolean(
  process.env.PLAYWRIGHT_TEST_BASE_URL ||
    process.env.PLAYWRIGHT ||
    process.env.CI_PLAYWRIGHT
);

export const DND_5E_CORE_ID = "5e5e5e5e-5e5e-5e5e-5e5e-5e5e5e5e5e5e"; // Deterministic UUID for the 5e Core Ruleset
export const CAMPAIGN_ID = "123e4567-e89b-12d3-a456-426614174000";
export const DEBUG_CAMPAIGN_ID = "11111111-1111-1111-1111-111111111111";
export const DEBUG_USER_ID = "22222222-2222-2222-2222-222222222222";
export const BYPASS_ADMIN_ID = "BYPASS_ADMIN";
export const GLOBAL_CAMPAIGN_ID = "global";

export const GRID_CELL_SIZE = 40;

export const CAMPAIGN_ID_HEADER = "x-campaign-id";
export const INTERNAL_SERVICE_KEY_HEADER = "x-internal-service-key";

/** Upper bound for player-supplied campaign system instructions at launch
 * (spec §2's MAX_INSTRUCTIONS — enforced in the tool input schema; the
 * bootstrap repository does not length-check).
 *
 * Deliberately NOT placed beside `DEFAULT_CAMPAIGN_INSTRUCTIONS`
 * (`lib/db/schema.ts`): that file is Drizzle infrastructure (pulls in
 * drizzle-orm/pg-core table definitions), and this constant must be
 * importable from `lib/core/schemas/account-character.ts`, which the
 * Sovereign Kernel boundary forbids from depending on the DB layer
 * (CLAUDE.md §4 — Systems never access the database directly). No
 * existing `lib/core/schemas/*` file imports from `lib/db`; this constant
 * does not start that precedent. `lib/constants.ts` is already imported
 * by `account-character.ts` (`DND_5E_CORE_ID`). */
export const MAX_CAMPAIGN_SYSTEM_INSTRUCTIONS_LENGTH = 20_000;
